import PropTypes from 'prop-types';
import { createContext, useContext, useMemo, useState } from 'react';
import { componentMainTitle } from '../../utils/miscConstants';

export const HealthyDealsDataContext = createContext();
export const useHealthyDealsDataContext = () =>
	useContext(HealthyDealsDataContext);

export default function HealthyDealsDataContextProvider({
	redirectToResourceLibrary = null,
	children,
	isUserAuthenticated = false,
	redirectToLogin = null,
	redirectToNetworkSearch = null,
	setMainTitleTo = componentMainTitle,
	description = null,
	updatePageTitleAndDescription,
	componentRootPath,
}) {
	const [topHeadingElementRef, setTopHeadingElementRef] = useState(null);
	const [selectedCategorySavedInContext, setSelectedCategorySavedInContext] =
		useState(null);
	const [prevPageTitle, setPrevPageTitle] = useState(null);
	const [paginationPageFromContext, setPaginationPageFromContext] = useState(1);
	const [skipDataForPageFromContext, setSkipDataForPageFromContext] =
		useState(0);

	return (
		<HealthyDealsDataContext.Provider
			value={useMemo(
				() => ({
					redirectToResourceLibrary,
					isUserAuthenticated,
					redirectToLogin,
					redirectToNetworkSearch,
					setMainTitleTo,
					description,
					topHeadingElementRef,
					setTopHeadingElementRef,
					selectedCategorySavedInContext,
					setSelectedCategorySavedInContext,
					prevPageTitle,
					setPrevPageTitle,
					paginationPageFromContext,
					setPaginationPageFromContext,
					skipDataForPageFromContext,
					setSkipDataForPageFromContext,
					updatePageTitleAndDescription,
					componentRootPath,
				}),
				[
					redirectToResourceLibrary,
					isUserAuthenticated,
					redirectToLogin,
					redirectToNetworkSearch,
					setMainTitleTo,
					description,
					topHeadingElementRef,
					setTopHeadingElementRef,
					selectedCategorySavedInContext,
					setSelectedCategorySavedInContext,
					prevPageTitle,
					setPrevPageTitle,
					paginationPageFromContext,
					setPaginationPageFromContext,
					skipDataForPageFromContext,
					setSkipDataForPageFromContext,
					updatePageTitleAndDescription,
					componentRootPath,
				],
			)}
		>
			{children}
		</HealthyDealsDataContext.Provider>
	);
}
HealthyDealsDataContextProvider.propTypes = {
	children: PropTypes.node.isRequired,
	redirectToResourceLibrary: PropTypes.func,
	isUserAuthenticated: PropTypes.bool,
	redirectToLogin: PropTypes.func,
	redirectToNetworkSearch: PropTypes.func,
	setMainTitleTo: PropTypes.string,
	description: PropTypes.string,
	updatePageTitleAndDescription: PropTypes.func.isRequired,
	componentRootPath: PropTypes.string.isRequired,
};
